import { render, staticRenderFns } from "./TeachingUserPaperLogList.vue?vue&type=template&id=bdd3be22&scoped=true"
import script from "./TeachingUserPaperLogList.vue?vue&type=script&lang=js"
export * from "./TeachingUserPaperLogList.vue?vue&type=script&lang=js"
import style0 from "./TeachingUserPaperLogList.vue?vue&type=style&index=0&id=bdd3be22&prod&scoped=true&lang=css"
import style1 from "./TeachingUserPaperLogList.vue?vue&type=style&index=1&id=bdd3be22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd3be22",
  null
  
)

export default component.exports